import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api 的 base_url
  timeout: 480000, // 请求超时时间
  withCredentials: true
})

// request拦截器
service.interceptors.request.use(
  config => {
    config.headers.common = {
      'Authorization': 'Bearer '+store.state.loginInfo.jwtToken
	}
	return config;
},
  error => {
    // Do something with request error
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
      return response.data
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js